import { Link } from "react-router-dom";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  morePath?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  morePath,
  moreLabel = "查看更多",
  icon = "ri-fire-line",
}: SectionHeaderProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-6">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center shrink-0">
          <i className={`${icon} text-xl`}></i>
        </span>
        <div>
          <h2 className="font-heading font-bold text-lg md:text-xl text-foreground-950">
            {title}
          </h2>
          {subtitle && (
            <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {morePath && (
        <Link
          to={morePath}
          className="hidden sm:flex items-center gap-1 text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      )}
    </div>
  );
}